export { default as GroupForm } from './GroupFormContainer';



// WEBPACK FOOTER //
// ./src/components/Admin/GroupForm/index.js